// extracted by mini-css-extract-plugin
export const footer = "Footer-module--footer--VRb5f";
export const socialLink = "Footer-module--socialLink--O2Rt2";